import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import Icon from './Icon';

/**
 * Компонент ToolCard - карточка для отображения инструмента
 * 
 * @param {object} tool - Объект инструмента из базы данных
 * @param {function} onClick - Обработчик клика (опционально)
 */
const ToolCard = ({ tool, onClick }) => {
  const colorMap = {
    finance: "indigo",
    health: "emerald",
    travel: "purple",
    web: "violet",
    home: "fuchsia",
    food: "orange",
    time: "cyan",
    generators: "violet",
    popular: "indigo"
  };
  
  const color = colorMap[tool.category] || "indigo";
  const toolUrl = `/tools/${tool.category}/${tool.id}`;
  
  // Если передан onClick, используем его, иначе просто перенаправляем по ссылке
  const handleClick = onClick ? onClick : undefined;
  
  return (
    <Link 
      to={toolUrl} 
      onClick={handleClick}
      className="block bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 hover:shadow-md transition-all duration-200 overflow-hidden cursor-pointer"
    >
      <div className="p-6">
        <div className="flex justify-between mb-4">
          <div className={`bg-${color}-50 dark:bg-gray-700 p-2.5 rounded-lg`}>
            <Icon 
              name={tool.iconName} 
              color={color}
              size="lg"
            />
          </div>
          
          {tool.usageCount && (
            <div className="px-2 py-1 rounded-md text-xs font-medium bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300">
              {tool.usageCount}
            </div>
          )}
        </div>
        
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
          {tool.name}
        </h3>
        
        <p className="text-gray-600 dark:text-gray-300 text-sm mb-4 line-clamp-2">
          {tool.description}
        </p>
        
        <div className="flex justify-between items-center mt-auto">
          <span className="text-sm text-gray-500 dark:text-gray-400">
            {tool.shortDesc}
          </span>
          
          <div className="flex">
            <div className="text-indigo-600 dark:text-indigo-400 hover:text-indigo-800 dark:hover:text-indigo-300 transition-colors">
              <ExternalLink className="h-5 w-5" />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ToolCard;